import React from "react";
import { Grid } from "@mui/material";
import { DEFAULT_SIZE } from "../../../utils/constant";
import PropTypes from "prop-types";

export default function InputWrapper({ children, size = DEFAULT_SIZE, className = "" }) {
  return (
    <Grid className={`proInputWrapper ${className}`.trim()} item md={size} xs={12}>
      {children}
    </Grid>
  );
}

InputWrapper.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number,
  className: PropTypes.string
};
